export default "__VITE_ASSET__DQA6jwis__"